























import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import { QueryTelephoneFollowList } from "@/api/follow/telephoneFollow";
@Component({})
export default class TelephoneFollow extends AbpBase {
  loading: boolean = false;
  response: any = {};
  payload = {
    QueryString: "",
    Page: 1,
    PageSize: 10
  };
  columns = [
    {
      title: "姓名",
      key: "pName",
      minWidth: 80
    },
    {
      title: "身份证",
      key: "cid",
      minWidth: 150
    },
    {
      title: "性别",
      key: "sexName",
      minWidth: 80
    },
    {
      title: "年龄",
      key: "age",
      minWidth: 80
    },
    {
      title: "医保卡号",
      key: "card",
      minWidth: 150
    },
    {
      title: "计划随访时间",
      key: "comeBack",
      minWidth: 150,
      render: (h: any, p: any) => {
        return h("span", this.formatDateTime(p.row.comeBack));
      }
    },
    {
      title: "计划通知时间",
      key: "callTime",
      minWidth: 150,
      render: (h: any, p: any) => {
        return h("span", this.formatDateTime(p.row.callTime));
      }
    },
    {
      title: "已通知次数",
      key: "times",
      minWidth: 120
    },
    {
      title: "通知结果",
      key: "followStatusName",
      minWidth: 120
    },
    {
      title: "随访设置时间",
      key: "start",
      minWidth: 150,
      render: (h: any, p: any) => {
        return h("span", this.formatDateTime(p.row.start));
      }
    },
    {
      title: "设置人",
      key: "remarkName",
      minWidth: 100
    }
  ];

  handlePageChange(val: any) {
    this.payload.Page = val;
    this.getData();
  }

  async getData() {
    this.loading = true;
    let res = await QueryTelephoneFollowList(this.payload);
    this.response = res;
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/follow/telephoneFollow/index.vue